import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const ScrollReveal = ({ children, delay = 0, className = '' }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);
  return (
    <div 
      ref={ref} 
      className={`transition-all duration-1000 ${className} ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Image */}
          <ScrollReveal>
            <div className="relative">
              <div className="aspect-[4/3] rounded overflow-hidden shadow-lg">
                <img 
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop" 
                  alt="Trueledger Team"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </ScrollReveal>

          {/* Right side - Content */}
          <div>
            <ScrollReveal delay={100}>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
                About Us
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={200}>
              <h3 className="text-2xl font-semibold text-[#3E2723] mb-6">
                Built on trust and driven by precision
              </h3>
            </ScrollReveal>
            <ScrollReveal delay={300}>
              <p className="text-gray-600 leading-relaxed mb-8">
                Trueledger supports businesses with clarity that moves them forward.
              </p>
            </ScrollReveal>
            
            {/* Stats */}
            <ScrollReveal delay={400}>
              <div className="grid grid-cols-3 gap-6">
                <div>
                  <div className="text-3xl font-bold text-[#3E2723] mb-2">10+</div>
                  <div className="text-sm text-gray-600">Happy Clients</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[#3E2723] mb-2">20+</div>
                  <div className="text-sm text-gray-600">Projects Done</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[#3E2723] mb-2">30+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;